export const reformatAddress = address => {
  const [streetAddress, city, zip] = address.split(',');
  return [`${streetAddress}`, `${city} ${zip}`];
};
